import { styled } from 'styled-components'

export const LoginPageContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const LeftPanel = styled.div`
  flex: 1;
  background: linear-gradient(135deg, #4d8cff 0%, #3568d4 100%);
  color: white;
  display: flex;
  flex-direction: column;
  padding: 2rem;
  position: relative;
  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxkZWZzPgogICAgPHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI1MCIgaGVpZ2h0PSI1MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxwYXRoIGQ9Ik0gNTAgMCBMIDAgMCAwIDUwIiBmaWxsPSJub25lIiBzdHJva2U9IiM4MGIzZmYiIHN0cm9rZS13aWR0aD0iMC41Ii8+CiAgICA8L3BhdHRlcm4+CiAgPC9kZWZzPgogIDxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiIC8+CiAgPGNpcmNsZSBjeD0iMTAlIiBjeT0iMTAlIiByPSI1JSIgZmlsbD0icmdiYSgyNTUsMjU1LDI1NSwwLjEpIiAvPgogIDxjaXJjbGUgY3g9IjkwJSIgY3k9IjMwJSIgcj0iMTAlIiBmaWxsPSJyZ2JhKDI1NSwyNTUsMjU1LDAuMSkiIC8+CiAgPHBhdGggZD0iTTAgNTAgQyAyMCAyMCwgODAgODAsIDEwMCA1MCBTIDE4MCAxMDAsIDIwMCA1MCIgc3Ryb2tlPSJyZ2JhKDI1NSwyNTUsMjU1LDAuMSkiIHN0cm9rZS13aWR0aD0iMiIgZmlsbD0ibm9uZSIgLz4KPC9zdmc+'),
    linear-gradient(135deg, #4d8cff 0%, #3568d4 100%);

  @media (max-width: 768px) {
    padding: 1.5rem;
    min-height: 300px;
  }
`

export const CompanyLogo = styled.div`
  font-size: 1.2rem;
  font-weight: 500;
  opacity: 0.8;
  display: flex;
  align-items: center;

  &:before {
    content: '';
    display: inline-block;
    width: 24px;
    height: 24px;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 50%;
    margin-right: 0.5rem;
  }
`

export const WelcomeText = styled.div`
  margin: auto 0;
  max-width: 450px;

  p {
    font-size: 0.9rem;
    line-height: 1.5;
    opacity: 0.8;
    margin-top: 1rem;
  }
`

export const WelcomeTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0.5rem 0;
  letter-spacing: 1px;
  position: relative;
  padding-bottom: 0.75rem;

  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 50px;
    height: this;
    border-bottom: 3px solid white;
  }

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`

export const WelcomeSubtitle = styled.p`
  font-size: 1rem;
  font-weight: 400;
  margin: 0;
`

export const RightPanel = styled.div`
  flex: 1;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;

  @media (max-width: 768px) {
    padding: 1.5rem;
  }
`

export const LoginFormContainer = styled.form`
  width: 100%;
  max-width: 400px;
`

export const LoginTitle = styled.h2`
  font-size: 1.8rem;
  color: #4d8cff;
  margin: 0 0 0.5rem;
  font-weight: 600;
`

export const LoginSubtitle = styled.p`
  color: #8a8a8a;
  font-size: 0.85rem;
  line-height: 1.5;
  margin: 0 0 2rem;
`

export const InputContainer = styled.div`
  margin-bottom: 1.25rem;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 60%;
    background-color: #4d8cff;
  }
`

export const StyledInput = styled.input`
  width: 100%;
  padding: 0.8rem 1rem 0.8rem 1.5rem;
  border: none;
  border-radius: 0;
  border-bottom: 1px solid #e0e0e0;
  font-size: 0.95rem;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #4d8cff;
  }

  &::placeholder {
    color: #b9b9b9;
  }
`

export const FormRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
`

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
`

export const StyledCheckbox = styled.input`
  margin-right: 0.5rem;
  cursor: pointer;
  accent-color: #4d8cff;
`

export const RememberMeText = styled.label`
  font-size: 0.85rem;
  color: #8a8a8a;
  cursor: pointer;
`

export const AlreadyMemberText = styled.a`
  font-size: 0.85rem;
  color: #4d8cff;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

export const SubmitButton = styled.button`
  width: 100%;
  padding: 0.9rem;
  background-color: #4d8cff;
  color: white;
  border: none;
  border-radius: 25px;
  font-size: 0.9rem;
  font-weight: 600;
  letter-spacing: 1px;
  cursor: pointer;
  transition:
    background-color 0.2s,
    transform 0.2s;

  &:hover {
    background-color: #3a70d4;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background-color: #a5c6f1;
    cursor: not-allowed;
    transform: none;
  }
`
